export { ArticleContaminantTable } from './ArticleContaminantTable';
